import { VideoMode } from "@/logic/videobridge/videomode";
import type { Item } from "./collections/itemcollection";
import { NamedItemCollection } from "./collections/nameditemcollection";
import type { ITableBase } from "./interfaces/table";
import type User from "./user";

export const TABLE_NAME = {
    LOBBY: "#LOBBY#",
    OPEN: "#open#",
    CLOSED: "#closed#",
    WAITING: "#waiting#",
} as const;

export enum TABLE_FILTER {
    SCORING_METHOD = 1,
    COMPLETE_TABLE = 2,
    PLAYABLE_FOR_LEVEL = 3, // gaat nu altijd in combi met COMPLETE_TABLE = 0
    FROM_LEVEL = 4, // gaat nu altijd in combi met COMPLETE_TABLE = 1.
}

export const LOBBY_ID = 1;

// export interface ITable {
// 	id: number,
// 	name: string,
// 	scoringMethod: number,
//     playingMode: number,
//     levelFrom: number,
//     levelTo: number,
//     allowUndo: boolean,
//     nPlayers: number,
//     nMembers: number,
//     label: string,
//     isVugraph: boolean,
//     teamsLinkedTables: string,
//     isTeam: boolean,
//     isMaster: boolean,
//     twoHalves: boolean,
//     nBoards: number,
//     allowVisitors: boolean, // when disabled, new users at this table become spectator immediately.
//     isModerated: boolean,
//     boardMin: number,
//     boardMax: number,
//     isReserved: boolean,
//     isInCarousel: boolean,
//     videoMode: number,
//     sortingString: string, // create this for sorting
// }



export class DTable implements ITableBase, Item {
    id = LOBBY_ID;
    name = "";
    scoringMethod = 0;
    playingMode = 0;
    levelFrom = 0;
    levelTo = 0;
    allowUndo = false;
    nPlayers = 0;
    nMembers = 0;
    label = "";
    isVugraph = false;
    teamsLinkedTables = "";
    isTeam = false;
    isMaster = false;
    twoHalves = false;
    nBoards = 0;
    allowVisitors = false; // when disabled, new users at this table become spectator immediately.
    isModerated = false;
    boardMin = 0;
    boardMax = 0;
    isReserved = false;
    isInCarousel = false;
    videoMode = 0; // TODO VideoBridge.Mode.NONE;
    sortingString = ""; // create this for sorting

    constructor(id?: number) {
        this.id = id ?? LOBBY_ID;
    }
}

export interface IHasPlayers {
    players: string[] | undefined[];
}

export default class Table extends DTable {
    static readonly LOBBY_ID = 1;

    playForDeclarer = false;
    users = new NamedItemCollection<User>();

    get players() {
        let p = Array<User | undefined>(4);
        for (let i of [0, 1, 2, 3]) {
            p[i] = this.getPlayer(i);
        }
        return p;
    }

    getPlayer(chairIndex: number) {
        return this.users.toArray().find((v) => {
            return v.chair.index === chairIndex;
        });
    }

    getPartnerName(playerName: string): string {
        const p = this.users.get(playerName);

        if (p && p.isPlayer()) {
            return this.getPlayer(p.chair.partner().index)?.name ?? '';
        }
        return '';
    }

    constructor(id?: number) {
        super(id);
    }

    reset() {
        Object.assign(this, new DTable());
        this.playForDeclarer = false;
        this.users.clear();
    }

    equals(o: Table) {
        return o && o.name === this.name;
    }

    isLobby() {
        return this.id === LOBBY_ID;
    }

    hasVideo() {
        return this.videoMode !== VideoMode.NONE;
    }

    createSortingString() {
        if (this.teamsLinkedTables.length > 0) {
            this.sortingString = this.teamsLinkedTables;
        } else {
            try {
                let prefix = "";
                let number = "";
                for (let c of this.name) {
                    if (c >= "0" && c <= "9") {
                        number += c;
                    } else if (number.length == 0) {
                        prefix += c;
                    }
                }
                if (number.length > 0) {
                    let ti = Number(number);
                    this.sortingString =
                        prefix +
                        Intl.NumberFormat("EN", {
                            minimumIntegerDigits: 6,
                            useGrouping: false,
                        }).format(ti);
                }
            } catch (e: any) {
                console.warn("Table.createSortingString()", e.msg);
            }
        }

        this.sortingString += this.isMaster ? "_0" : "_1";
    }
}
